/**
 * Created by wjy on 2018-10-11
 */
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import toast from '@util/toast';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import 'antd/lib/input/style/css';
import 'antd/lib/button/style/css';
import './index.scss';

@inject('store')
@observer
export default class AccountLogin extends React.Component<any, any> {
    public loginNav: any = ['账号登录', '扫码登录'];
    public nameInput: any;
    public codeInput: any;
    public getCodeTimer: any;
    public hasGetCode: boolean = false; // 是否已经发送成功验证码
    public constructor(props) {
        super(props);
        this.init();
    }
    public init() {
        this.state = {
            currentNav: 0,
            getCodeBtnDisabled: true,
            phone: '',
            code: '',
            submitBtnDisabled: true,
            getCodeBtnCon: '获取验证码',
        };
    }
    public switchNav = (index) => {
        this.setState({
            currentNav: index,
        });
    }
    public getPhoneCode = (param, fn) => {
        this.props.store.getPhoneCode.init(param).then((res) => {
            console.log('发送验证码成功===>', res);
            fn(res);
        }).catch((err) => {
            console.log('发送验证码失败====>', err);
            fn(false);
        });
    }
    public login = (param) => {
        this.props.store.dataLoginToken.init(param).then((res) => {
            console.log('登录成功==========>', res);
            const userInfo = JSON.stringify(res);
            window.localStorage.setItem('ACCESSTOKEN', res.token);
            window.localStorage.setItem('USERINFO', userInfo);
            this.props.hasLogin();
        }).catch((err) => {
            console.log('登录失败=========>', err);
            toast.error(err.msg);
        });
    }
    public getCodeBtn = () => {
        const { phone, getCodeBtnCon } = this.state;
        const param: any = {};
        param.mobile = phone;
        param.businessIdType = 1;
        this.getPhoneCode(param, (res) => {
            if (res) {
                this.hasGetCode = true;
                let countNum = 60;
                this.setState({
                    getCodeBtnDisabled: true,
                    getCodeBtnCon: countNum,
                });
                this.getCodeTimer = setInterval(() => {
                    if (countNum > 0) {
                        countNum--;
                        this.setState({
                            getCodeBtnCon: countNum,
                        });
                    } else {
                        this.hasGetCode = false;
                        this.setState({
                            getCodeBtnCon: '重新获取',
                            getCodeBtnDisabled: false,
                        });
                        clearInterval(this.getCodeTimer);
                    }

                }, 1000);

            }
        });
    }
    public onchange = (e) => {
        console.log(e.target.name);
        const name = e.target.name;
        let value = e.target.value;
        if (name === 'phone') {
            value = value.replace(/\s+/g, '');
            value = value.replace(/[^\d]/g, '').substr(0, 11);
            if (!this.hasGetCode) {
                if (value.length === 11) {
                    this.setState({
                        getCodeBtnDisabled: false,
                    });
                } else {
                    this.setState({
                        getCodeBtnDisabled: true,
                    });
                }
            }
            this.setState({
                phone: value,
            });
        } else if (name === 'code') {
            value = value.replace(/\s+/g, '');
            value = value.replace(/[^\d]/g, '').substr(0, 4);
            this.setState({
                code: value,
            });
        }
        if (value) {
            this.setState({
                submitBtnDisabled: false,
            });
        } else {
            this.setState({
                submitBtnDisabled: true,
            });
        }
    }
    public loginSubmit = () => {
        const { phone, code } = this.state;
        const loginParam: any = {};
        if (code.length !== 4) {
            toast.error('请输入正确验证码');
            return;
        }
        loginParam.mobile = phone;
        loginParam.smsCode = code;
        this.login(loginParam);
    }
    public componentDidMount() {
        document.title = '理想社群文章发布平台';
    }
    public componentWillUnmount() {
        clearInterval(this.getCodeTimer);
    }
    public render() {
        const { phone, code, getCodeBtnDisabled, submitBtnDisabled, getCodeBtnCon } = this.state;
        return (
            <div className="account-box">
                <div className="input-box">
                    <Input size="large" ref={(ref) => this.nameInput = ref} onChange={this.onchange} placeholder="请输入手机号" name="phone" value={phone} />
                </div>
                <div className="input-box get-code">
                    <Input size="large" ref={(ref) => this.codeInput = ref} onChange={this.onchange} name="code" placeholder="请输入验证码" value={code} />
                    <Button type="primary" onClick={this.getCodeBtn} block={true} disabled={getCodeBtnDisabled}>{getCodeBtnCon}</Button>
                </div>
                <div className="login-button-box">
                    <Button size="large" onClick={this.loginSubmit} type="primary" block={true} disabled={submitBtnDisabled}>登录</Button>
                </div>
            </div>
        );
    }
}
